import * as React from 'react';
import * as styles from './style.css';
import { useDispatch } from 'react-redux';

import { IFromDevelopersRoom } from '../../types/newbuilding';
import { trackingActionClickDevelopersFlats } from '../../actions/analytics';
import { TTypedThunkDispatch } from '../../types/thunk';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import { UIHeading5, UIText2 } from '@cian/ui-kit';
import clsx from 'clsx';
import { plural } from '@cian/utils';

interface IAdvertiseProps {
  room: IFromDevelopersRoom;
  isPromoSnippet?: boolean;
  onOfferClick?(countDisplay: string): void;
}

const OFFER_VARIANTS: [string, string, string] = ['квартира', 'квартиры', 'квартир'];

export const Advertise = ({ room, isPromoSnippet, onOfferClick }: IAdvertiseProps) => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const onLinkClickHandler = React.useCallback(() => {
    if (onOfferClick) {
      onOfferClick(room.countDisplay);

      return;
    }
    dispatch(trackingActionClickDevelopersFlats(room.countDisplay));
  }, [dispatch, onOfferClick, room.countDisplay]);

  const offersCount = React.useMemo(() => {
    return `${room.offersCount} ${plural(room.offersCount, OFFER_VARIANTS)}`;
  }, [room.offersCount]);

  return (
    <a
      className={clsx(styles['advertise'], { [styles['advertise--promo']]: isPromoSnippet })}
      href={room.offersUrl}
      onClick={onLinkClickHandler}
      target="_blank"
      rel="noreferrer"
      data-testid="advertise"
    >
      <UIHeading5 color="current_color">{room.countDisplay}</UIHeading5>
      <UIText2 color="current_color">{`От${NO_BREAK_SPACE}${room.minTotalArea}${NO_BREAK_SPACE}м²`}</UIText2>
      <UIHeading5 color="current_color">{room.minPriceDisplay || room.price2Range}</UIHeading5>
      {isPromoSnippet && <UIText2 color="current_color">{offersCount}</UIText2>}
    </a>
  );
};
